import React from "react";
import CenterClassicPage from "../../components/institutional/CenterClassicPage";
import { centerPages } from "../../data/institutionalPageData";

export default function ElearningCenter() {
  return <CenterClassicPage data={centerPages.elearning} />;
}
